import React from 'react';
import { C, FILTER_TYPES } from './shared';
import FilterRow from './FilterRow';

export default function FilterPanel({ filters, onUpdate, onRemove, onToggleOperator, onAdd, onApply, hasPendingChanges }) {
  return (
    <div style={{
      background: '#fff',
      border: `1px solid ${C.border}`,
      borderRadius: 10,
      padding: '14px 16px',
      marginBottom: 14,
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{
          fontSize: 11, fontWeight: 700, color: C.textMd,
          textTransform: 'uppercase', letterSpacing: '0.05em',
        }}>
          Filter Results
        </div>
        <button
          onClick={onApply}
          style={{
            padding: '6px 18px',
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            border: 'none',
            background: hasPendingChanges ? C.primary : '#E2E8F0',
            color: hasPendingChanges ? '#fff' : C.textMd,
            transition: 'background 0.15s',
          }}
        >
          {hasPendingChanges ? '🔍 Apply Filters' : '✓ Applied'}
        </button>
      </div>

      {filters.length === 0 && (
        <div style={{ fontSize: 13, color: C.textSm, marginBottom: 12 }}>
          No filters applied — add one below.
        </div>
      )}

      {filters.map((f, i) => (
        <FilterRow
          key={f.id}
          filter={f}
          index={i}
          onUpdate={onUpdate}
          onRemove={onRemove}
          onToggleOperator={onToggleOperator}
        />
      ))}

      {/* + Add filter buttons */}
      <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: C.textSm, marginRight: 2 }}>+ Add filter:</span>
        {FILTER_TYPES.map(t => (
          <button
            key={t.value}
            onClick={() => onAdd(t.value)}
            style={{
              padding: '3px 10px', borderRadius: 5, fontSize: 12, cursor: 'pointer', fontWeight: 500,
              border: `1px solid ${C.border}`, background: '#F8FAFC', color: C.textMd,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}
